import { render } from "./Branch.vue?vue&type=template&id=6cc87acc&scoped=true&ts=true"
import script from "./Branch.vue?vue&type=script&lang=ts"
export * from "./Branch.vue?vue&type=script&lang=ts"

import "./Branch.vue?vue&type=style&index=0&id=6cc87acc&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cc87acc"]])

export default __exports__